/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boiling a soft-boiled egg with a just-set white and runny yolk.`)
};

const es_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hervir un huevo pasado por agua con la clara recién cuajada y la yema líquida.`)
};

const de_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein weichgekochtes Ei mit gerade festem Eiweiß und flüssigem Dotter kochen.`)
};

const nl_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een zachtgekookt ei koken met een net gestold eiwit en een lopende dooier.`)
};

const fr_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuire un œuf mollet au blanc tout juste pris et au jaune coulant.`)
};

const it_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuocere un uovo alla coque con l'albume appena rappreso e il tuorlo liquido.`)
};

const pt_br2_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cozinhar um ovo com a clara recém-firmada e a gema mole.`)
};

const pt_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cozer um ovo escalfado com a clara mesmo firme e a gema líquida.`)
};

const ja_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白身がちょうど固まり黄身がとろりとした半熟卵をゆでる。`)
};

const zh_timer_u3m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`煮一颗溏心蛋，蛋白刚好凝固，蛋黄仍呈流动状。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_use1", locale)
	if (locale === "en") return en_timer_u3m_use1(inputs)
	if (locale === "es") return es_timer_u3m_use1(inputs)
	if (locale === "de") return de_timer_u3m_use1(inputs)
	if (locale === "nl") return nl_timer_u3m_use1(inputs)
	if (locale === "fr") return fr_timer_u3m_use1(inputs)
	if (locale === "it") return it_timer_u3m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_use1(inputs)
	if (locale === "pt") return pt_timer_u3m_use1(inputs)
	if (locale === "ja") return ja_timer_u3m_use1(inputs)
	return zh_timer_u3m_use1(inputs)
};